import React, { Component } from "react";
import StripeInputWrapperViewProps from "./StripeInputWrapperViewProps";
import { FormControl, InputLabel, Input } from "@material-ui/core";
import TranslationView from "../../../../../../../../components/Translation/TranslationView";

export default class StripeInputWrapperView extends Component<StripeInputWrapperViewProps> {

    render() {
        const { label, component, style } = this.props;

        return (
            <FormControl style={style}>
                <InputLabel shrink>
                    {TranslationView.translate(label)}
                </InputLabel>
                
                <Input inputComponent={component as any} />
            </FormControl>
        );
    }
}